import { DeleteOutlined } from "@ant-design/icons";
import { Flex, Progress } from "antd";
import type { UploadFile } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";

export const UploadProgress = ({
  file,
  onAbort,
  remove,
  showRemoveIcon,
}: {
  file: UploadFile;
  onAbort: () => void;
  remove: () => void;
  showRemoveIcon: boolean;
}) => {
  const { theme } = useAntTheme();
  return (
    <Flex align="center" gap={10} style={{ margin: "10px 0px" }}>
      <Progress
        strokeColor={theme.colorPrimary}
        percent={Math.round(file.percent ?? 0)}
      />
      {showRemoveIcon !== false && (file.percent ?? 0) < 100 && (
        <DeleteOutlined
          style={{
            fontSize: 16,
          }}
          onClick={() => {
            (
              file as {
                abort?: () => void;
              }
            )?.abort?.();
            onAbort?.();
            remove();
          }}
        />
      )}
    </Flex>
  );
};
